module.exports = __webpack_public_path__ + "assets/media/morning.6137ed46.mp3";